module.exports = __webpack_public_path__ + "static/media/guru-nanak-dev-ji-diya-2.45432142.gif";